<template lang="html">
  <div :class="['symbium-form-group', klass]">
    <div class="form-label" v-if="label">{{ label }}</div>
    <div class="gap-1x" v-if="label" />
    <SymbiumInputWithError
      :placeholder="placeholder"
      :type="type"
      :value="value"
      :error="error"
      :locked="locked"
      :displayError="displayError"
      :inputSize="inputSize"
      :iconClass="iconClass"
      :onIconClick="onIconClick"
      :disabled="disabled"
      @update:value="value => $emit('update:value', value)"
      @input:value="value => $emit('input:value', value)"
    />
    <div
      v-if="leftLinkText"
      class="left-link"
      @click="$emit('left-link-click')"
    >
      {{ leftLinkText }}
    </div>
  </div>
</template>

<script>
import SymbiumInputWithError from 'src/components/common/SymbiumInputWithError.vue'

export default {
  components: { SymbiumInputWithError },
  props: {
    klass: {
      type: String,
      default: '',
    },
    inputSize: {
      type: String,
      default: 'input-default-size',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    value: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: undefined,
    },
    leftLinkText: {
      type: String,
      default: undefined,
    },
    locked: {
      type: Boolean,
      default: false,
    },
    displayError: {
      type: Boolean,
      default: true,
    },
    iconClass: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    onIconClick: {
      type: Function,
      default: () => {},
    }
  },
}
</script>

<style lang="scss">
.symbium-form-group {
  width: fit-content;
  
  .form-label {
    color: #6d6d6d;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
  }

  .left-link {
    width: 100%;
    padding-top: 8px;
    cursor: pointer;

    color: #979797;
    font-size: 14px;
    line-height: 20px;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
